export default "__VITE_ASSET__DwevocOv__"